import React, { useState, useEffect } from "react";

const URL = "https://cs-api.aimedicare.ng/chat-widget/x/";

const ChatWidget: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) return null;

	return (
		<>
			{/* Floating Button */}
			<button
				id="cb-btn"
				style={{ backgroundColor: "#168807" }}
				onClick={() => setIsOpen(true)}
				aria-label="Open support chat"
			>
				💬
			</button>

			{/* Popup */}
			<div
				id="cb-popup"
				style={{ display: isOpen ? "flex" : "none" }}
			>
				<div id="cb-head" style={{ backgroundColor: "#168807" }}>
					<span>Live Support</span>
					<button
						id="cb-close"
						onClick={() => setIsOpen(false)}
						aria-label="Close support chat"
					>
						&times;
					</button>
				</div>
				<iframe
					src={URL}
					id="cb-frame"
					allow="clipboard-write; microphone"
				/>
			</div>

			<style>{`
				#cb-btn {
					position: fixed;
					bottom: 20px;
					right: 20px;
					width: 60px;
					height: 60px;
					background: #007bff;
					color: #fff;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 30px;
					cursor: pointer;
					z-index: 999999;
					box-shadow: 0 4px 14px rgba(0,0,0,.25);
					border: none;
					outline: none;
				}

				#cb-popup {
					position: fixed;
					bottom: 90px;
					right: 20px;
					width: 380px;
					height: 650px;
					background: #fff;
					border-radius: 16px;
					overflow: hidden;
					flex-direction: column;
					z-index: 999999;
					box-shadow: 0 8px 30px rgba(0,0,0,.25);
				}

				#cb-head {
					height: 55px;
					background: #007bff;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 16px;
					font: 700 16px Arial;
				}

				#cb-close {
					cursor: pointer;
					font-size: 28px;
					background: none;
					border: none;
					outline: none;
					color: #fff;
					padding: 0;
					line-height: 1;
				}

				#cb-frame {
					width: 100%;
					height: 100%;
					border: 0;
				}

				@media(max-width:768px) {
					#cb-popup {
						width: calc(100vw - 30px);
						height: 80vh;
						right: 15px;
					}
				}

				@media(max-width:480px) {
					#cb-popup {
						width: 100vw;
						height: 100vh;
						right: 0;
						bottom: 0;
						border-radius: 0;
					}
				}
			`}</style>
		</>
	);
};

export default ChatWidget;
